<template>
  <div class="containerTable fundFlowReportwrap">
    <div class="remarks">
      若平台使用银企支付，银行流水返回一般为第二天，建议隔日后再上报
    </div>
    <vxe-toolbar
      id="toolbarId_ca12"
      :custom="{ storage: true }"
      export
      :refresh="{ query: RefreshList }"
    >
      <template v-slot:buttons>
        <el-button
          v-if="getLimit('fundFlowReporting_search_button')"
          @click="funcFilter()"
        >
          查询
        </el-button>
        <el-button
          v-if="getLimit('fundFlowReporting_export_button')"
          @click="funcExport()"
        >
          导出
        </el-button>
        <el-button
          v-if="
            getLimit('fundFlowReporting_batchReport_button') &&
              !isAutomaticReport
          "
          @click="getSelectEvent()"
        >
          批量上报
        </el-button>
        <el-button
          v-if="getLimit('fundFlowReporting_serial_button')"
          @click="funcSerial()"
          >获取流水号</el-button
        >
      </template>
    </vxe-toolbar>
    <div class="total_fee">
      <span>运费总额:</span>
      <span>{{ totalShipmentDeliveryFeePractical || "--" }}元</span>
    </div>
    <vxe-table
      ref="xTable"
      resizable
      border
      stripe
      highlight-current-row
      show-footer
      highlight-hover-row
      row-id="id"
      class="mytable-footer"
      height="80%"
      :footer-method="footerMethod"
      :loading="loading"
      :data="tableData"
      :sort-config="{ remote: true }"
      export-config
      show-overflow
      align="center"
      @sort-change="sortList"
    >
      <vxe-table-column type="checkbox" width="60" fixed="left" />
      <vxe-table-column type="seq" title="序号" width="60" fixed="left" />
      <vxe-table-column>
        <vxe-table-column
          field="branchCode"
          title="承运主体"
          :formatter="formatterBranch"
          min-width="260"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.branchCode"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in branchList"
              :key="item.code"
              :label="item.groupName"
              :value="item.code"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="invoiceStatus"
          title="是否开票"
          :formatter="formatterInvoiceStatus"
          min-width="140"
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.invoiceStatus"
            clearable
            placeholder="请选择"
          >
            <el-option label="未开票" value="0" />
            <el-option label="已开票" value="1" />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="isSplitOrder"
          title="是否分单"
          :formatter="formatterOverload"
          min-width="100"
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.isSplitOrder"
            clearable
            placeholder="请选择"
          >
            <el-option label="否" value="0" />
            <el-option label="是" value="1" />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="orderCode"
          title="运输单号"
          min-width="250"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.orderCode"
            placeholder="点击批量输入运单号"
            clearable
            style="cursor: pointer;"
            @focus="batchInputDialogVisible = true"
          />
          <!-- <el-input
            v-model="listQuery.orderCode"
            placeholder="请输入内容"
            clearable
          /> -->
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="shippingNoteNumber"
          title="托运单号"
          min-width="250"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.shippingNoteNumber"
            placeholder="请输入内容"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="placeOfShipment"
          title="装货地"
          min-width="400"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.placeOfShipment"
            placeholder="请输入内容"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="placeOfReceipt"
          title="卸货地"
          min-width="400"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.placeOfReceipt"
            placeholder="请输入内容"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="ordCreatedByName"
          title="托运人名称"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.ordCreatedByName"
            placeholder="请输入内容"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="ordCreatedByPhone"
          title="托运人手机号"
          min-width="160"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.ordCreatedByPhone"
            placeholder="请输入内容"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="driverName"
          title="实际承运人"
          min-width="140"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.driverName"
            placeholder="请输入内容"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="vehicleLicense"
          title="车牌号"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.vehicleLicense"
            placeholder="请输入内容"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="driverPhone"
          title="联系方式"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.driverPhone"
            placeholder="请输入内容"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="shipmentDeliveryFeePractical"
          title="托运人实际运费"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.shipmentDeliveryFeePracticalStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.shipmentDeliveryFeePracticalEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="deliveryFeePractical"
          title="实付运费"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.deliveryFeePracticalStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.deliveryFeePracticalEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="deliveryCashFee"
          title="实际承运人实收运费"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.deliveryCashFeeStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.deliveryCashFeeEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <!-- <vxe-table-column>
        <vxe-table-column field="deliveryOilFee" title="油气卡" min-width="200" sortable />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input v-model="listQuery.deliveryOilFeeStart" type="number" placeholder="下限" clearable />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input v-model="listQuery.deliveryOilFeeEnd" type="number" placeholder="上限" clearable />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column> -->
      <vxe-table-column>
        <vxe-table-column
          field="fundErrMsg"
          title="上传结果"
          min-width="150"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.fundErrMsg"
            placeholder="请输入内容"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="isSendFund"
          title="上报状态"
          :formatter="formatterSendFundStatus"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.isSendFund"
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in sendFundOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="isSend"
          title="路单上报状态"
          :formatter="formatterSendStatus"
          min-width="150"
          sortable
        />
        <template v-slot:header>
          <el-select v-model="listQuery.isSend" clearable placeholder="请选择">
            <el-option
              v-for="item in sendOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="payTime"
          title="到账时间"
          min-width="420"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.payTimeRange"
            value-format="yyyy-MM-dd"
            type="daterange"
            :picker-options="optionsPicker"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'payTime')"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="sendFundTime"
          title="上报时间"
          min-width="420"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.sendFundTimeRange"
            value-format="yyyy-MM-dd"
            type="daterange"
            :picker-options="optionsPicker"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'sendFundTime')"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="modifiedByName"
          title="最后操作人"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.modifiedByName"
            placeholder="请输入内容"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column title="操作" min-width="220" fixed="right">
        <template slot-scope="scope">
          <el-tooltip
            v-if="getLimit('fundFlowReporting_orderDetail_button')"
            class="item"
            effect="dark"
            content="运单详情"
            placement="top"
          >
            <vxe-button type="text" @click="orderDesil(scope.row.code)">
              <em class="el-icon-document" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip
            v-if="
              getLimit('fundFlowReporting_reportTransportFund_button') &&
                scope.row.isSendFund != 1 &&
                !(isAutomaticReport && scope.row.isSendFund != 2)
            "
            class="item"
            effect="dark"
            content="上报流水"
            placement="top"
          >
            <vxe-button type="text" @click="orderopen(scope.row.code)">
              <em class="el-icon-top-right" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip
            v-if="
              getLimit('fundFlowReporting_split_button') &&
                scope.row.isSplitOrder != 0
            "
            class="item"
            effect="dark"
            content="分单"
            placement="top"
            width="50"
          >
            <vxe-button type="text" @click="splitOrder(scope.row.code)">
              <em class="el-icon-tickets" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip
            v-if="getLimit('fundFlowReporting_history_button')"
            class="item"
            effect="dark"
            content="打款记录"
            placement="top"
          >
            <vxe-button type="text" @click="moneyHistoury(scope.row.code)">
              <em class="el-icon-notebook-2" />
            </vxe-button>
          </el-tooltip>
        </template>
      </vxe-table-column>
    </vxe-table>
    <vxe-pager
      :loading="loading"
      :page-sizes="Pagingconf"
      :current-page.sync="listQuery.pageNum"
      :page-size.sync="listQuery.pageSize"
      :total="listQuery.total"
      :layouts="[
        'PrevJump',
        'PrevPage',
        'Number',
        'NextPage',
        'NextJump',
        'Sizes',
        'FullJump',
        'Total'
      ]"
      @page-change="handlePageChange"
    />
    <vxe-modal
      v-model="tuteship"
      title="运输单详情"
      width="1000"
      height="80%"
      resize
    >
      <ordergoods ref="detailRef" />
    </vxe-modal>
    <vxe-modal
      v-model="splitOrderFlag"
      title="子单详情"
      width="800"
      height="85%"
      resize
    >
      <splitOrder ref="splitOrderRef" />
    </vxe-modal>
    <vxe-modal
      v-model="datagramFlag"
      title="报文详情"
      width="1000"
      height="80%"
      resize
    >
      <fundDatagramDetail ref="datagramRef" />
    </vxe-modal>
    <fundMoneyHistory ref="HistoryRef" :parent-data="parentData" />
    <downloadData ref="downloadRef" />
    <el-dialog
      title="批量输入运单号"
      :visible.sync="batchInputDialogVisible"
      width="650px"
      height="900px"
      class="batch-input-dialog"
    >
      <BatchWaybill
        :codes="listQuery.orderCode"
        @confirmBatchInput="confirmBatchInput"
      />
    </el-dialog>
  </div>
</template>
<script>
import BatchWaybill from "@/components/BatchWaybill";
import { hubeiList, reportHubeiTransportFund } from "@/api/transport";
import ordergoods from "@/components/WaybillDetails";
import { queryReceiptNo } from "@/api/InternetBanking";
import fundDatagramDetail from "./components/fundDatagramDetail.vue";
import splitOrder from "@/views/tms/order/splitOrder";
import fundMoneyHistory from "./components/fundMoneyHistory.vue";
import { mapState } from "vuex";
export default {
  components: {
    ordergoods,
    fundDatagramDetail,
    splitOrder,
    fundMoneyHistory,
    BatchWaybill
  },
  data() {
    return {
      totalShipmentDeliveryFeePractical: 0,
      batchInputDialogVisible: false,
      exportObj: {
        exportUrl: "/ntocc-tms-api/orderDetail/exportFundFlowReport", //导出接口
        name: "资金上报"
      },
      tuteship: false,
      datagramFlag: false,
      splitOrderFlag: false,
      message: "",
      loading: false,
      tableData: [],
      listQuery: {
        sendFundTimeRange: "",
        payTimeRange: "",
        pageNum: 1,
        pageSize: 20,
        total: 0,
        status: 6,
        reportMark: 0,
        isSendFund: "",
        isSend: "",
        fundErrMsg: "",
        isReportPage: 1, // 上报页面查询需传1
        notEqualIsTransfer: 2 // 状态2，不能上报
      },
      parentData: {},
      sumObject: {},
      loginkTarget: 0,
      toolbarButtons: [
        {
          code: "btn1",
          name: "查询"
        },
        {
          code: "btn1",
          name: "更新京东打款状态"
        },
        {
          code: "btn1",
          name: "更新交通打款状态"
        },
        {
          code: "btn1",
          name: "更新传化支付打款状态"
        }
      ],
      sendFundOptions: [
        {
          value: "0",
          label: "未上报"
        },
        {
          value: "1",
          label: "已上报"
        },
        {
          value: "2",
          label: "上报失败"
        }
      ],
      sendOptions: [
        {
          value: "0",
          label: "未上报"
        },
        {
          value: "1",
          label: "已上报"
        },
        {
          value: "2",
          label: "上报失败"
        }
      ],
      formatterInvoiceStatus({ cellValue }) {
        switch (cellValue) {
          case 1:
            return "已开票";
          case 0:
            return "未开票";
        }
      },
      formatterOverload({ cellValue }) {
        switch (cellValue) {
          case 1:
            return "是";
          case 0:
            return "否";
          default:
            return "否";
        }
      },
      // 机构列表
      branchList: this.$store.state.components.branchList
    };
  },
  computed: {
    ...mapState({
      isAutomaticReport: state => state.user.party.isAutomaticReport
    })
  },
  created() {
    let dataBranch = JSON.parse(localStorage.getItem("dataBranch"));
    this.loginkTarget = dataBranch.partyGroupConfigCacheMap
      .loginkTarget_reportProvince
      ? dataBranch.partyGroupConfigCacheMap.loginkTarget_reportProvince
          .configValue
      : 0;
    this.findList();
  },
  methods: {
    confirmBatchInput(parsedOrderCodes) {
      if (parsedOrderCodes.length > 300) {
        this.$message.warning("运单号数量不能超过300个");
        return;
      }
      this.listQuery.orderCode = parsedOrderCodes.join(",");
      this.batchInputDialogVisible = false;
      this.funcFilter();
    },
    findList() {
      this.loading = true;
      return new Promise(resolve => {
        hubeiList(this.listQuery).then(response => {
          this.tableData = response.data.records;
          this.tableData.forEach(item => {
            item.weight = item.weight + item.coalUnitName;
            item.loadQuantity = item.loadQuantity + item.coalUnitName;
            item.unloadQuantity = item.unloadQuantity + item.coalUnitName;
          });
          this.listQuery.total = response.data.total;
          this.totalShipmentDeliveryFeePractical =
            response.data.sumObject.shipmentDeliveryFeePractical;
          this.loading = false;
          resolve();
        });
      });
    },
    // 翻译机构
    formatterBranch({ cellValue }) {
      const item = this.branchList.find(item1 => item1.code === cellValue);
      return item ? item.groupName : "";
    },
    //分单
    splitOrder(row) {
      this.$refs.splitOrderRef.findList(row);
      this.splitOrderFlag = true;
    },
    orderopen(c) {
      this.$confirm("请确认是否要发送资金流水到 网络货运监测平台？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          const rLoading = this.openLoading();
          const codes = c;
          reportHubeiTransportFund({ codes })
            .then(response => {
              this.$message({
                type: "success",
                message: response.msg
              });
              rLoading.close();
            })
            .finally(() => {
              this.$refs.xTable.clearCheckboxRow();
              this.findList();
              rLoading.close();
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消"
          });
        });
    },
    async funcSerial(item) {
      let checkedRowArray = item
        ? [item]
        : this.$refs.xTable.getCheckboxRecords();
      if (!checkedRowArray || checkedRowArray.length === 0) {
        this.$message.warning("请选择需要获取的项");
        return;
      } else if (checkedRowArray.length > 20) {
        this.$message.warning("批量处理最多20条数据");
        return;
      }
      let branchCode = checkedRowArray[0].branchCode;
      let codes = [];
      for (let subItem of checkedRowArray) {
        if (subItem.branchCode != branchCode) {
          this.$message.warning("请选择同一机构");
          return;
        }
        codes.push(subItem.code);
      }
      codes = codes.join(",");
      const rLoading = this.openLoading();
      // let response = await queryReceiptNo({ codes });
      await queryReceiptNo({ codes });
      rLoading.close();
      // alert(2)
      // this.$message.success(response.msg);
      this.findList();
    },
    getSelectEvent() {
      const selectRecords = this.$refs.xTable.getSelectRecords();
      if (!selectRecords || selectRecords.length === 0) {
        this.$message({ message: "请选择运单", type: "warning" });
      } else if (selectRecords.length > 100) {
        this.$message({ message: "一次最多上报100条数据", type: "warning" });
      } else {
        var branchCode = "";
        var flag = true;
        for (var i = 0; i < selectRecords.length; i++) {
          branchCode = selectRecords[0].branchCode;
          if (branchCode !== selectRecords[i].branchCode) {
            flag = false;
          }
        }
        if (!flag) {
          this.$message({ message: "请选择同一机构的信息！", type: "error" });
        } else {
          const codes = selectRecords.map(item => item.code).join(",");
          this.$confirm("确认上报监管平台吗？").then(_ => {
            const rLoading = this.openLoading();
            reportHubeiTransportFund({ codes })
              .then(response => {
                rLoading.close();
                this.$message({ message: response.msg, type: "success" });
              })
              .finally(() => {
                this.$refs.xTable.clearCheckboxRow();
                this.findList();
              });
          });
        }
      }
    },
    orderDesil(c) {
      this.$refs.detailRef.Getdetails(c);
      this.tuteship = true;
    },
    fundDatagram(c) {
      this.$refs.datagramRef.getDatagram(c);
      this.datagramFlag = true;
    },
    moneyHistoury(c) {
      this.$refs.HistoryRef.show(c);
    },
    formatterSendFundStatus({ cellValue }) {
      switch (cellValue) {
        case 0:
          return "未上报";
        case 1:
          return "已上报";
        case 2:
          return "上报失败";
        default:
          break;
      }
    },
    formatterSendStatus({ cellValue }) {
      switch (cellValue) {
        case 0:
          return "未上报";
        case 1:
          return "已上报";
        case 2:
          return "上报失败";
        default:
          break;
      }
    },
    footerMethod({ columns, data }) {
      return [
        columns.map((column, columnIndex) => {
          if (columnIndex === 0) {
            return "合计";
          }
          if (
            [
              "deliveryFeePractical",
              "deliveryCashFee",
              "shipmentDeliveryFeePractical"
            ].includes(column.property)
          ) {
            return this.$XEUtils.sum(data, column.property);
          }
          if (column.property === "weight") {
            return (
              this.sumObject.ton +
              "吨//" +
              this.sumObject.cubicMeter +
              "方//" +
              this.sumObject.pieces +
              "件"
            );
          }
          if (column.property === "loadQuantity") {
            return (
              this.sumObject.loadQuantityTon +
              "吨//" +
              this.sumObject.loadQuantityCubicMeter +
              "方//" +
              this.sumObject.loadQuantityPieces +
              "件"
            );
          }
          if (column.property === "unloadQuantity") {
            return (
              this.sumObject.unloadQuantityTon +
              "吨//" +
              this.sumObject.unloadQuantityCubicMeter +
              "方//" +
              this.sumObject.unloadQuantityPieces +
              "件"
            );
          }
          return "-";
        })
      ];
    }
  }
};
</script>

<style lang="scss">
.remarks {
  color: #d01415;
  font-size: 10px;
  margin-bottom: 10px;
}
</style>
<style lang="scss" scoped>
.fundFlowReportwrap {
  position: relative;
}
.total_fee {
  position: absolute;
  top: 35px;
  right: 103px;
  font-weight: bold;
  color: #333;

  span:last-child {
    color: #d01415;
  }
}
</style>
